import { useDeleteTenantUsuario } from "core/features/tenants/hooks";
import { showConfirm, showSuccess, showErrorAxios } from "infra/helpers/alerta";
import HeaderTable from "ui/components/Page/HeaderTable";
import useListagemUsuariosTenantColumns from "./components/useListagemUsuariosTenantColumns";
import { UsuariosTableProps } from "./types";
import NewTable from "components/NewTable";
import { TenantUsuarioItem } from "core/features/tenants/typings/tenant";
import UsuariosEvents from "./events";
import useReenvioEmailSenha from "core/features/usuario/hooks/useReenvioEmailSenha";
import { useLoading } from "components/GlobalLoading";

function UsuariosTable({
  data,
  searchValue,
  onPaginate,
  onSearch,
  onEdit,
  onDeleted,
  isLoading,
  tenantId,
  onClickRow,
}: UsuariosTableProps) {
  const { mutate: deleteUser, isLoading: isLoadinngDelete } =
    useDeleteTenantUsuario();

  const { mutate: reenvioEmailSenha, isLoading: isLoadingReenviar } =
    useReenvioEmailSenha();

  useLoading(isLoadingReenviar);

  const handleDelete = (usuario: any) => {
    showConfirm().then(({ isConfirmed }) => {
      if (isConfirmed) {
        deleteUser(
          { tenantId, usuarioId: usuario.id },
          { onSuccess: () => onDeleted() }
        );
      }
    });
  };

  const columns = useListagemUsuariosTenantColumns();

  return (
    <>
      <NewTable<TenantUsuarioItem>
        title={() => <HeaderTable value={searchValue} onSearch={onSearch} />}
        loading={isLoading || isLoadinngDelete}
        columns={columns}
        dataSource={data?.items ?? []}
        customPagination={{
          onChangePage: onPaginate,
          currentPage: data?.meta.currentPage ?? 0,
          itemsPerPage: data?.meta.itemsPerPage ?? 0,
          totalItems: data?.meta.totalItems ?? 0,
        }}
        onRow={(record) => ({
          onClick: () => onClickRow!(record),
          style: {
            cursor: "pointer",
          },
        })}
        actions={[
          {
            title: "Editar",
            onClick: (v: any) => onEdit(v),
          },
          {
            title: "Reenviar e-mail com senha",
            onClick: (data) => {
              reenvioEmailSenha(
                {
                  users: typeof data.id === "string" ? [data.id] : data.id,
                  type: "email",
                },
                {
                  onSuccess: () => {
                    showSuccess();
                  },
                  onError: (err) => {
                    showErrorAxios(err);
                  },
                }
              );
              UsuariosEvents.reenviarEmailSenhaEvent(data.id);
            },
          },
          {
            title: "Excluir",
            onClick: (v: any) => handleDelete(v),
          },
        ]}
      />
    </>
  );
}

export default UsuariosTable;
